class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.mainForm = document.querySelector('form[action*="/cart/add"]');
    this.stickyForm = this.querySelector('form');
    this.threshold = 300; // Show after scrolling 300px
    this.isCustomPage = window.location.pathname.includes('/pages/');
    this.isDiamondPage = window.location.pathname.includes('diamond-details');
    this.mainAddToCartBtn = document.querySelector('#tps_buy_loose_diamond') || document.querySelector('#tps_buy_loose_gemstone');
    this.stickyAddToCartBtn = this.querySelectorAll('.tps-add-to-cart');
    
    this.init();
  }

  init() {
    this.setupEventListeners();
    if (!this.isCustomPage) {
      this.syncForms();
    } else {
      this.setupCustomPageSync();
    }
  }

  setupEventListeners() {
    window.addEventListener('scroll', this.handleScroll.bind(this));
    
    if (this.mainForm && this.stickyForm && !this.isCustomPage) {
      // Sync variant selection between forms for regular products
      this.mainForm.addEventListener('change', () => {
        const selectedVariantId = this.mainForm.querySelector('[name="id"]').value;
        this.stickyForm.querySelector('[name="id"]').value = selectedVariantId;
        
        // Update price in button when variant changes
        const variantPrice = this.mainForm.closest('product-info').querySelector('.price__regular .price-item--regular').textContent;
        this.stickyForm.querySelector('.price-amount').textContent = variantPrice;
      });
    }
  }

  setupCustomPageSync() {
    // For diamond/gemstone pages
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          this.updateCustomPageContent();
        }
      });
    });

    // Observe the main content area for changes
    const config = { childList: true, characterData: true, subtree: true };
    observer.observe(document.body, config);

    // Initial sync
    this.updateCustomPageContent();
  }

  updateCustomPageContent() {
    // Update price and details for custom pages
    const priceElement = document.querySelector('#diamond_price') || document.querySelector('#gemstone_price');
    const detailsElement = document.querySelector('#diamond_title') || document.querySelector('#gemstone_title');
    const imageElement = document.querySelector('.tps-diamond-stock-image');
    
    if (priceElement) {
      const priceText = priceElement.textContent;
      // Update both the info section and button price
      const stickyPrices = this.querySelectorAll('.price-display');
      stickyPrices.forEach(el => el.textContent = priceText);
    }
    
    if (detailsElement) {
      const stickyDetails = this.querySelectorAll('.diamond-details');
      stickyDetails.forEach(el => el.textContent = detailsElement.textContent);
    }

    if (imageElement) {
      const imageSrc = imageElement.src;
      const stickyImages = this.querySelectorAll('.tps-diamond-stock-image');
      stickyImages.forEach(el => el.src = imageSrc);
    }
  }

  handleScroll() {
    if (window.pageYOffset > this.threshold) {
      this.classList.add('is-visible');
    } else {
      this.classList.remove('is-visible');
    }
  }

  syncForms() {
    if (!this.mainForm || !this.stickyForm) return;

    // Sync initial variant selection for regular products
    const selectedVariantId = this.mainForm.querySelector('[name="id"]').value;
    this.stickyForm.querySelector('[name="id"]').value = selectedVariantId;

    // Initial price sync
    const variantPrice = this.mainForm.closest('product-info').querySelector('.price__regular .price-item--regular').textContent;
    this.stickyForm.querySelector('.price-amount').textContent = variantPrice;
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart); 